export default __webpack_public_path__ + "static/O0166-5724734df8be682793008d14901fc8b6.png";